import type { FunctionComponent } from 'react'
import { Suspense } from 'react'

import { AnimatePresence } from 'motion/react'
import { ErrorBoundary } from 'react-error-boundary'
import { Outlet } from 'react-router-dom'
// import AnimatedOutlet from './AnimatedOutlet'
import { styled } from 'styled-components'

import { DeveloperNavigation } from 'DeveloperNavigation'
import { ErrorFallback } from 'components/ErrorFallback'
import { useLocalStorageState } from 'hooks/useLocalStorageState'
import { SettingsModal } from 'modals/settings'
import { getAdminMode, setAdminMode } from 'storage'
import { DebugFlag } from 'theme/debug'
import { MAX_WIDTH } from 'theme/theme'

import { useAppContext } from './AppContext'
import { LoadingScreen } from './views/loading'

const View = styled.main`
  margin: 0 auto;
  max-width: ${MAX_WIDTH};
  width: 100%;
  height: 100vh;

  & > div {
    position: relative;
    z-index: 0;
  }
  & > div:not(:first-of-type) {
    left: 0;
    margin: 0 auto;
    max-width: ${MAX_WIDTH};
    position: absolute;
    right: 0;
    top: 0;
    width: 100%;
  }
`

export const App: FunctionComponent = () => {
  const { contentLoaded, loadFailure } = useAppContext()
  const [adminMode] = useLocalStorageState(getAdminMode, setAdminMode)

  return (
    <>
      <AnimatePresence mode="wait">
        {!contentLoaded && !loadFailure && (
          <div className="loading-screen-wrap">
            <LoadingScreen />
          </div>
        )}
      </AnimatePresence>
      {loadFailure ? (
        <ErrorFallback />
      ) : (
        <>
          <DeveloperNavigation />
          {adminMode && <DebugFlag>Admin Mode</DebugFlag>}
          <SettingsModal />
          <View>
            <ErrorBoundary FallbackComponent={ErrorFallback}>
              <Suspense fallback={<div className="loading-screen" />}>
                {/* <AnimatedOutlet /> */}
                <Outlet />
              </Suspense>
            </ErrorBoundary>
          </View>
        </>
      )}
    </>
  )
}

export default App
